import { useState } from 'react';
import readFile from 'utils/readFile';
import uploadGpxFile from './uploadGpxFile';
import {
  STATUS_PENDING,
  STATUS_UPLOADING,
  STATUS_SUCCESS,
  STATUS_ERROR,
} from './constants';

function makeEntry(file, idx) {
  return {
    id: `${Date.now()}-${idx}`,
    file,
    name: file.name.replace(/\.gpx$/i, ''),
    status: STATUS_PENDING,
  };
}

function useGpxBatchUpload(user) {
  const [files, setFiles] = useState([]);

  function updateFile(id, changes) {
    setFiles(prev =>
      prev.map(entry => (entry.id === id ? { ...entry, ...changes } : entry)),
    );
  }

  async function uploadOne(entry) {
    updateFile(entry.id, { status: STATUS_UPLOADING });
    try {
      const gpx = await readFile(entry.file);
      const { routeId } = await uploadGpxFile({
        gpx,
        description: entry.name,
        user,
      });
      updateFile(entry.id, { status: STATUS_SUCCESS, routeId });
    } catch (error) {
      updateFile(entry.id, { status: STATUS_ERROR, error: error.message });
    }
  }

  function addFiles(fileList) {
    const newEntries = Array.from(fileList).map(makeEntry);
    setFiles(prev => [...prev, ...newEntries]);
    newEntries.reduce(
      (previous, entry) => previous.then(() => uploadOne(entry)),
      Promise.resolve(),
    );
  }

  return { files, addFiles };
}

export default useGpxBatchUpload;
